import { Navigate, Outlet, useLocation } from "react-router-dom";
import useWrapper from "../../hooks/useWrapper";

export default function RequireAuthGestor() {
  const { me } = useWrapper();

  const location = useLocation();
  return me?.type === "Gestor" ? (
    <Outlet />
  ) : me?.type === "Formando" ? (
    <Navigate to="/" state={{ from: location }} replace />
  ) : (
    <Navigate to="/gestor" state={{ from: location }} replace />
  );
}
